import axios from "axios";
import { getLang } from "@/utils/langs";

/**
 * 调用 API ，类似 fetch 风格
 *
 * @param url: 支持"//"开头的泛解析url
 * @param opts: {
 *   method: GET / POST,
 *   params: { string: string } URL参数，参考 axios 的 api 设计
 *   body: { string: string } GET / HEAD 请求不能使用 body
 *   timeout: 单位毫秒
 *   withCredentials: 是否需要带 cookie，默认 false
 *   cache: 类似 $.ajax 的 cache，只对 GET / HEAD 有效，默认 true ，如果设置为 false 则会通过添加时间戳来防止浏览器缓存
 * }
 */
function call(url, opts) {
  opts = opts || {};
  opts.method = opts.method || "GET";
  // const timeoutErrMsg = "call.timeout: " + JSON.stringify({ url: url, opts: opts });
  let p;

  if (opts.method == "POST") {
    if (opts.dataFormat == "json") {
      p = axios({
        url: url,
        method: opts.method,
        data: opts.params,
        params: {
          ct: opts.params.ct,
          region: opts.params.region,
          web_code: opts.params.web_code,
        },
        responseType: "json",
        withCredentials: opts.withCredentials,
        timeout: opts.timeout || 0,
      });
    } else {
      var data = Object.assign({}, opts.params);
      delete data.region;
      delete data.lang;
      if (opts.dataFormat === "multipart/form-data") {
        p = axios({
          url,
          method: opts.method,
          data: opts.params.data,
          responseType: "json",
          withCredentials: opts.withCredentials,
          timeout: opts.timeout || 0,
          params: {
            ct: opts.params.ct,
            region: opts.params.region,
            web_code: opts.params.web_code,
            lang: opts.params.lang,
          },
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        p = axios({
          url: url,
          method: opts.method,
          data: data,
          responseType: "json",
          withCredentials: opts.withCredentials,
          timeout: opts.timeout || 0,
          params: {
            ct: opts.params.ct,
            region: opts.params.region,
            web_code: opts.params.web_code,
            lang: opts.params.lang,
            game_id: opts.params.addExtra && opts.params.game_id,
            currency: opts.params.addExtra && opts.params.currency,
          },
          headers: {
            "Content-Type":
              opts.dataFormat || "application/x-www-form-urlencoded",
          },
          transformRequest: [
            function(data) {
              // Do whatever you want to transform the data
              let ret = "";
              for (let it in data) {
                ret +=
                  encodeURIComponent(it) +
                  "=" +
                  encodeURIComponent(data[it]) +
                  "&";
              }
              ret = ret.replace(/&$/, "");
              return ret;
            },
          ],
        });
      }
    }
  } else {
    p = axios({
      url: url,
      method: opts.method,
      params: opts.params,
      responseType: "json",
      withCredentials: opts.withCredentials,
      timeout: opts.timeout || 0,
    });
  }

  return p;
}

/**
 * 依次调用 urlList 中的 API ，前一个出错则调用后一个(接口切线)
 */
function callWithFallback(urlList, opts) {
  // urlList 长度必须 > 0
  return urlList.slice(1).reduce(function(p, curUrl) {
    return p.catch(() => call(curUrl, opts));
  }, call(urlList[0], opts));
}

/**
 * 语言。en：英文，ja：日文，ko：韩文，zh：繁体中文。传错或不传，默认：en英文
 */
const langs = {
  5: "ja",
  6: "ko",
};

/**
 * 定义一个 API
 *
 * @param method: GET / POST
 * @param url: 不能有请求参数或 hash
 * @param paramNames: 参数名数组，为 null 则表示定义出来的 api 只传入一个参数 object
 * @param init: {
 *   withCredentials: 是否需要带 cookie ，默认 false
 *   timeout: 超时，单位毫秒
 *   cache: 只对 GET / HEAD 有效，是否允许浏览器默认缓存，默认 true
 * }
 */
function api(method, url, paramNames, init, mode) {
  init = init || {};
  return function() {
    const args = arguments;
    const data = {};
    if (typeof args[0] == "object") {
      Object.assign(data, args[0]);
    } else {
      if (paramNames) {
        paramNames.forEach((name, i) => {
          // gourl必传，在此处理
          if (args[i] !== "" || name === "gourl") {
            data[name] = args[i];
          }
        });
      }
    }
    const opts = {
      method,
      dataFormat: init.dataFormat,
      withCredentials: init.withCredentials,
      timeout: init.timeout,
      cache: init.cache,
    };
    // if (method == "GET" || method == "HEAD") {
    // 是否在post请求的url上拼接lang
    if (init.postUrlLang) {
      data.lang = langs[process.env.VUE_APP_SOURCE];
    }
    // 是否拼接region参数
    if (init.region8) {
      data.region = 8;
    }
    opts.params = data;
    opts.params.lang = getLang();
    // 接口统一添加region参数
    if (!data.region && mode !== "pay") {
      Object.assign(opts.params, {
        region: process.env.VUE_APP_SOURCE,
      });
    }

    // 添加web_code,删除region
    if (init.web_code) {
      data.web_code = init.web_code;
      delete opts.params.region;
    }
    // } else {
    // 	opts.body = data;
    // }
    if (Array.isArray(url)) {
      return callWithFallback(url, opts);
    } else {
      return call(url, opts);
    }
  };
}

/**
 * 根据当前 url 的协议处理泛解析 url ，默认 https
 */
function https(url) {
  if (url.startsWith("//")) {
    return (location.protocol == "http:" ? "http:" : "https:") + url;
  } else {
    return url;
  }
}

const ApiUtil = {
  call,
  callWithFallback,
  api,
  https,
};

export default ApiUtil;
